import { Component, Input } from '@angular/core';
import { ListBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-list',
  templateUrl: './mr-list.component.html',
  styleUrls: ['./mr-list.component.scss'],
})
export class MrListComponent extends MessageBlockBaseDirective {
  @Input() block!: ListBlock;
}
